<div class="success-modal">
  <div class="success-ico" *ngIf="!data?.image">
    <i class="bi bi-check-circle-fill"></i>
  </div>
  <img class="success-image" *ngIf="data?.image" [src]="data.image" alt="" />
  <p class="success-message">{{ data.message }}</p>
</div>
